import { createFetch } from '@vueuse/core'
import { destr } from 'destr'
import { router } from '@/plugins/1.router/index'
import { userAbilityRulesStorage } from '@layouts/plugins/casl'

export const useApi = createFetch({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '',
  fetchOptions: {
    headers: {
      Accept: 'application/json',
    },
  },
  options: {
    refetch: true,
    mode: 'cors',
    redirect: 'manual',
    async beforeFetch({ options, url }) {
      const userToken = getValidUserToken()

      // 強制禁用快取 Header
      options.headers = {
        ...options.headers,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }

      // 針對 GET 請求加上時間戳記 (Cache Busting)
      // 注意: useApi 的 url 可能是字串
      let finalUrl = url
      if (!options.method || options.method.toUpperCase() === 'GET') {
        const separator = finalUrl.includes('?') ? '&' : '?'
        finalUrl = `${finalUrl}${separator}t=${Date.now()}`
      }

      if (userToken) {
        options.headers = {
          ...options.headers,
          'X-Token': userToken,
        }
      }
      return { options, url: finalUrl }
    },
    afterFetch(ctx) {
      const { data, response } = ctx
      console.debug('afterFetch ctx', ctx)

      // Parse data if it's JSON

      let parsedData = null
      try {
        parsedData = destr(data)
        console.debug('afterFetch parsedData', parsedData)
      }

      catch (error) {
        console.error(error)
      }

      return { data: parsedData, response }
    },
    onFetchError(ctx) {
      console.debug('onFetchError ctx', ctx)
      const { data, response } = ctx

      if (data == null && response == null) {
        useStorage('userData', {}).value = null
        useCookie('userToken').value = null
        // 使用共享的 ref 清空，確保與 isHidden 函數同步
        userAbilityRulesStorage.value = []

        location.href = location.origin
      }

      if (response?.status == 401 || response?.status == 302) {
        const currentPath = window.location.pathname + window.location.search
        doLogout(router,currentPath)
      }
      
    },
  },
})
